import { NdpsDomainResponse } from '../../../types/bff-types';
import { fetchBff } from './bff-fetch';

// DOMAIN
export const fetchNdpsDomain = async (token: string, domain: string): Promise<NdpsDomainResponse | null> => {
	return fetchBff(`ndps/domain?token=${token}&domain=${domain}`);
};

export const fetchNdpsDomainRelated = async (
	token: string,
	domain: string,
	relatedDomain: string,
	relatedValue: string,
): Promise<NdpsDomainResponse | null> => {
	return fetchBff(
		`ndps/domain?token=${token}&domain=${domain}&relatedDomain=${relatedDomain}&relatedValue=${relatedValue}`,
	);
};

// PRELOAD
export const fetchNdpsPreload = async (pincode: string, token: string): Promise<NdpsDomainResponse | null> => {
	return fetchBff(`ndps/preload?pincode=${pincode}&token=${token}`);
};

// RESPONSES
export const fetchNdpsResponses = async (formData: FormData): Promise<NdpsDomainResponse | null> => {
	return fetchBff('ndps/responses', formData);
};
